import { CardListBaseTemplate, CardListBaseTemplateProps } from "./template";

export type PaymentMethodCardProps = CardListBaseTemplateProps;

export const CardListBase = (props: PaymentMethodCardProps): JSX.Element => {
  return <CardListBaseTemplate {...props} />;
};
